import React from 'react';
import { XCircle, AlertTriangle, Activity } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white px-4" data-id="element-148">
      <div className="max-w-3xl mx-auto" data-id="element-149">
        {/* The Problem */}
        <div className="mb-20" data-id="element-150">
          <div className="flex items-center gap-3 mb-6" data-id="element-151">
            <AlertTriangle className="w-8 h-8 text-brand-amber" data-id="element-152" />
            <h2 className="font-serif text-3xl md:text-4xl text-brand-dark" data-id="element-153">
              Después de los 45 años, tu cuerpo cambia las reglas del juego.
            </h2>
          </div>
          <p className="text-lg text-brand-dark/80 leading-relaxed mb-6" data-id="element-154">
            Lo que antes funcionaba, ahora te inflama. Has pasado semanas
            comiendo "sano", tomando jugos verdes y gastando fortunas en
            colágeno o probióticos que prometen milagros en 30 días.
          </p>
          <p className="text-lg text-brand-dark/80 leading-relaxed mb-6" data-id="element-155">
            Pero la realidad es cruel: la báscula no se mueve, tu abdomen sigue
            abultado por la tarde y el dolor en las articulaciones te roba las
            ganas de salir.
          </p>
          <div className="bg-brand-bg p-6 rounded-xl border border-brand-teal/20" data-id="element-156">
            <p className="text-lg font-medium text-brand-dark leading-relaxed" data-id="element-157">
              Estás atrapado en un ciclo de "Estrés-Cortisol-Hinchazón" donde tu
              cuerpo cree que está bajo ataque y, como defensa, retiene cada
              gramo de líquido y activa señales de dolor constante.
            </p>
          </div>
        </div>

        {/* Why it didn't work */}
        <div className="mb-20" data-id="element-158">
          <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-8 text-center" data-id="element-159">
            Por qué lo que has intentado hasta ahora NO ha funcionado
          </h2>
          <div className="space-y-4" data-id="element-160">
            {['Los jugos detox y la fibra en exceso suelen irritar un colon ya sensible, causando más gases e inflamación de la que intentas eliminar.', 'Los fármacos antiinflamatorios comunes solo tapan el síntoma mientras dañan tu revestimiento intestinal, creando un ciclo de dependencia.', "Las dietas de 'pasar hambre' elevan tu cortisol, lo que obliga a tus riñones a retener sodio y te mantiene hinchada a pesar de no comer.", 'Los suplementos de moda no pueden actuar si tus células están saturadas de desechos metabólicos que no dejas drenar.', "El agua sola no hidrata; si no tiene los minerales correctos, se queda atrapada entre tus tejidos creando esa sensación de 'cuerpo de chicle'."].map((item, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg hover:bg-red-50 transition-colors" data-id="element-161">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-162" />
                <p className="text-lg text-brand-dark/80" data-id="element-163">{item}</p>
              </div>)}
          </div>
        </div>

        {/* The Unique Mechanism */}
        <div className="bg-brand-teal text-white p-8 md:p-12 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-164">
          <div className="absolute top-0 right-0 opacity-10 transform translate-x-1/4 -translate-y-1/4" data-id="element-165">
            <Activity className="w-64 h-64" data-id="element-166" />
          </div>
          <div className="relative z-10" data-id="element-167">
            <h2 className="font-serif text-3xl md:text-4xl mb-6" data-id="element-168">
              La clave no es una dieta, es el "Interruptor de Cortisol"
            </h2>
            <p className="text-lg md:text-xl leading-relaxed mb-6 opacity-90" data-id="element-169">
              Este protocolo utiliza una combinación exacta de hidratación
              isotónica y activación de baja frecuencia del nervio vago para
              enviar una señal de "seguridad" a tu cerebro.
            </p>
            <p className="text-lg md:text-xl leading-relaxed font-medium" data-id="element-170">
              En menos de 48 horas, obligamos a tu sistema a soltar el agua
              retenida, vaciar las reservas de glucógeno inflamatorio y sellar
              las micro-fugas de tu intestino. Es un reset biológico de
              emergencia, no una restricción calórica.
            </p>
          </div>
        </div>
      </div>
    </section>;
}